var Socials = /*#__PURE__*/function (Socials) {
  Socials["INSTAGRAM"] = "instagram";
  Socials["TIKTOK"] = "tiktok";
  Socials["TWITTER"] = "twitter";
  Socials["FACEBOOK"] = "facebook";
  Socials["LINKEDIN"] = "linkedIn";
  return Socials;
}(Socials || {});
const availableSocials = ['instagram', 'tiktok', 'twitter', 'facebook', 'linkedIn'];
export const getSocials = socials => {
  return (socials || []).reduce((acc, social) => {
    if (social.link && social.name && /^(https|http):.+/.test(social.link) && availableSocials.includes(social.name)) {
      acc.push({
        name: social.name,
        url: social.link
      });
      return acc;
    }
    if (social.name === Socials.TIKTOK) {
      acc.push({
        name: social.name,
        url: `https://www.tiktok.com/${social.link}`
      });
    }
    if (social.name === Socials.INSTAGRAM) {
      acc.push({
        name: social.name,
        url: `https://www.instagram.com/${social.link}`
      });
    }
    if (social.name === Socials.TWITTER) {
      acc.push({
        name: social.name,
        url: `https://twitter.com/${social.link}`
      });
    }
    if (social.name === Socials.FACEBOOK) {
      acc.push({
        name: social.name,
        url: `https://www.facebook.com/${social.link}`
      });
    }
    if (social.name === Socials.LINKEDIN) {
      acc.push({
        name: social.name,
        url: `https://www.linkedin.com/${social.link}`
      });
    }
    return acc;
  }, []);
};